import axios from 'axios';
import { AuthService } from './auth.service';
import { ENDPOINTS } from '../constants/endpoints';
import { IApprovalControls } from '../interfaces/approvalControl.interface';

export const ApprovalControlService = {
    // Read: INSTITUTION_SETTINGS_VIEW
    get: async (institutionId: string): Promise<IApprovalControls> => {
        const response = await axios.get(ENDPOINTS.APPROVAL_CONTROLS.BY_INSTITUTION(institutionId), { headers: AuthService.getAuthHeader() });
        return response.data;
    },

    // Write: INSTITUTION_SETTINGS_MANAGE
    save: async (institutionId: string, body: IApprovalControls): Promise<IApprovalControls> => {
        const response = await axios.put(ENDPOINTS.APPROVAL_CONTROLS.BY_INSTITUTION(institutionId), body, { headers: AuthService.getAuthHeader() });
        return response.data;
    },
};
